<template>
    <div>
        <!-- <el-breadcrumb
            v-if="hasRoleToReadLogs"
            style="float: right"
            separator-class="el-icon-arrow-right"
        >
            <el-breadcrumb-item :to="{ path: '/' }">{{$t('route.home')}}</el-breadcrumb-item>
            <el-breadcrumb-item> {{$t('entities.teamManager.plural')}}</el-breadcrumb-item>
        </el-breadcrumb>-->
        <h2 class="page-title">{{$t('entities.teamManager.plural')}}</h2>

        <el-row :gutter="20">
            <el-col :xs="24" :md="8">
                <el-form @submit.native.prevent class="search" :inline="true">
                    <el-form-item>
                        <el-input v-model="pager.search" :placeholder="$t('table.search')">
                            <el-button slot="append" icon="el-icon-search"></el-button>
                        </el-input>
                    </el-form-item>
                </el-form>
            </el-col>

            <el-col class="button-group" :xs="24" :md="16">
                <!-- CREATE -->
                <el-button
                    v-if="hasRoleToCreate"
                    icon="el-icon-fa-file-o"
                    @click="create()"
                    type="primary"
                >{{$t('table.add')}}</el-button>
                <!-- EXPORT PDF -->
                <el-button
                    v-if="hasRoleToCreate && !teamId"
                    icon="el-icon-download"
                    @click="exportAsPdf()"
                    type="primary"
                >{{$t('table.exportAsPdf')}}</el-button>
                <!-- HISTORY -->
                <el-button
                    v-if="hasRoleToReadLogs"
                    icon="el-icon-fa-history"
                    @click="history()"
                    type="infor"
                >{{$t('table.history')}}</el-button>
                <el-button
                    v-if="pager.hasDataToExport(list) && hasRoleToReadLogs"
                    @click="pager.exportToCsv(list)"
                    :plain="true"
                    type="success"
                    icon="el-icon-fa-table"
                >{{$t('table.export')}}</el-button>
            </el-col>
        </el-row>
        <el-table
            :data="pager.paginate(list)"
            :default-sort="{
        prop: 'id',
        order: 'ascending'
      }"
            @row-click="rowClick"
            empty-text="There are no teamManageres yet"
            @sort-change="(args) => pager.sortChange(args)"
            style="width: 100%"
            v-loading="loading"
            border
        >
            <el-table-column
                prop="name"
                :label="$t('entities.teamManager.prop.name')"
                sortable="custom"
            ></el-table-column>

            <el-table-column
                prop="lastName"
                :label="$t('entities.teamManager.prop.lastName')"
                sortable="custom"
            ></el-table-column>
            <el-table-column
                v-if="hasRoleToCreate"
                prop="email"
                :label="$t('entities.teamManager.prop.email')"
                sortable="custom"
            ></el-table-column>

            <el-table-column
                prop="phone"
                :label="$t('entities.coach.prop.phone')"
                sortable="custom"
            ></el-table-column>

            <el-table-column
                v-if="hasRoleToReadLogs"
                prop="dni"
                :label="$t('entities.teamManager.prop.dni')"
                sortable="custom"
            ></el-table-column>

            <el-table-column
                v-if="hasRoleToReadLogs"
                prop="birthdate"
                :label="$t('entities.teamManager.prop.birthdate')"
                sortable="custom"
            >
                <template slot-scope="scope">{{ getDateFormat(scope.row.birthdate) }}</template>
            </el-table-column>

            <el-table-column v-if="!teamId" prop="team" :label="$t('entities.team.singular')" sortable="custom">
                <template slot-scope="scope">{{ scope.row.team ? scope.row.team.name : ' ' }}</template>
            </el-table-column>
            <el-table-column v-if="!teamId" prop="category" :label="$t('entities.category.singular')" sortable="custom">
                <template slot-scope="scope">{{ scope.row.team ? scope.row.team.category.label : ' ' }}</template>
            </el-table-column>

            <!-- ************************** -->
            <!-- *                        * -->
            <!-- *         Actions        * -->
            <!-- *                        * -->
            <!-- ************************** -->
            <el-table-column
                :fixed="isMobile? undefined : 'right'"
                align="center"
                :label="$t('table.actions')"
                width="120"
            >
                <template slot-scope="scope">
                    <el-tooltip
                        v-if="hasRoleToRead || hasRoleToReadClub"
                        :content="$t('table.details')"
                        placement="top"
                    >
                        <el-button
                            icon="el-icon-fa-search"
                            size="small"
                            type="text"
                            @click="show(scope.row.id)"
                        />
                    </el-tooltip>

                    <el-tooltip v-if="hasRoleToUpdate" :content="$t('table.edit')" placement="top">
                        <el-button
                            icon="el-icon-fa-pencil-square-o"
                            size="small"
                            type="text"
                            @click="edit(scope.row.id)"
                        />
                    </el-tooltip>

                    <el-tooltip
                        v-if="hasRoleToDelete"
                        :content="$t('table.delete')"
                        placement="top"
                    >
                        <el-button
                            icon="el-icon-fa-trash"
                            size="small"
                            type="text"
                            @click="destroy(scope.row)"
                        />
                    </el-tooltip>
                </template>
            </el-table-column>
        </el-table>

        <div class="mt-3">
            <el-pagination
                style="float: right"
                @size-change="(args) => pager.pageSizeChange(args)"
                :current-page.sync="pager.currentPage"
                :layout="paginationLayout"
                :total="pager.filteredAndSortedList(list).length"
                background
            ></el-pagination>
        </div>
    </div>
</template>

<script>
import UploadExcelComponent from "@/components/UploadExcel";
import { mapGetters } from "vuex";
import moment from "moment"; // birthdate
import Cookies from "js-cookie"; // birthdate

/* eslint-disable */

export default {
    name: "app-team-manager-list",
    components: { UploadExcelComponent },

    props: {
        teamId: String
    },
    data() {
        return {
            tableData: [],
            tableHeader: []
        };
    },
    computed: {
        ...mapGetters({
            loading: "entities/team-manager/loading",
            list: "entities/team-manager/list",
            pager: "entities/team-manager/pager",
            hasRoleToCreate: "entities/team-manager/hasRoleToCreate",
            hasRoleToRead: "entities/team-manager/hasRoleToRead",
            hasRoleToUpdate: "entities/team-manager/hasRoleToUpdate",
            hasRoleToDelete: "entities/team-manager/hasRoleToDelete",
            hasRoleToReadClub: "entities/club/hasRoleToRead",
            hasRoleToReadLogs: "entities/team-manager/hasRoleToReadLogs",
            isMobile: "shared/isMobile",
            paginationLayout: "shared/paginationLayout"
        })
    },

    created() {
        if (this.teamId) {
            this.$store.dispatch(
                "entities/team-manager/listByTeamId",
                this.teamId
            );
        } else {
            this.$store.dispatch("entities/team-manager/list");
        }
    },

    beforeRouteLeave(to, from, next) {
        this.$store.dispatch("entities/team-manager/clear");
        next();
    },

    beforeRouteUpdate(to, from, next) {
        this.$store.dispatch("entities/team-manager/list");
        next();
    },

    methods: {
        create() {
            this.$router.push({
                name: "teamManagerNew"
            });
        },

        rowClick(row, column, cell, event) {
            if (cell.label != this.$t("table.actions")) {
                this.$router.push({
                    name: "teamManagerShow",
                    params: { id: row.id }
                });
            }
        },

        show(id) {
            this.$router.push({
                name: "teamManagerShow",
                params: { id }
            });
        },

        edit(id) {
            this.$router.push({
                name: "teamManagerEdit",
                params: { id }
            });
        },

        destroy(model) {
            this.$confirm(
                this.$t("table.areYouSure"),
                this.$t("table.confirm"),
                {
                    confirmButtonText: this.$t("table.yes"),
                    cancelButtonText: this.$t("table.no"),
                    type: "warning"
                }
            )
                .then(() =>
                    this.$store.dispatch("entities/team-manager/destroy", model)
                )
                .then(() => {
                    if (this.teamId) {
                        this.$store.dispatch(
                            "entities/team-manager/listByTeamId",
                            this.teamId
                        );
                    } else {
                        this.$store.dispatch("entities/team-manager/list");
                    }
                })
                .catch(() => {});
        },

        history() {
            this.$router.push({ name: "teamManagerHistoryFull" });
        },

        exportAsPdf() {
            this.$store.dispatch("entities/team-manager/exportAsPDF");
        },
        // Functions upload excel
        beforeUpload(file) {
            const isLt1M = file.size / 1024 / 1024 < 1;

            if (isLt1M) {
                return true;
            }

            this.$message({
                message: "Please do not upload files larger than 1m in size.",
                type: "warning"
            });
            return false;
        },
        handleSuccess({ results, header }) {
            this.tableData = results;
            this.tableHeader = header;
        },
        // Aux functions
        getDateFormat(dateString) {
            console.log("<---- GET DATE FORMAT");
            console.log(dateString);
            console.log(new Date(dateString));

            return moment(dateString, ["YYYY-MM-DD"])
                .locale(Cookies.get("language") || "es")
                .format("L");
        }
    }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/entities/team-manager/team-manager-list.vue?27391ea8